import { render } from "./imgProfile.vue?vue&type=template&id=6f178260&scoped=true"
import script from "./imgProfile.vue?vue&type=script&lang=js"
export * from "./imgProfile.vue?vue&type=script&lang=js"

import "./imgProfile.vue?vue&type=style&index=0&id=6f178260&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f178260"]])

export default __exports__